import { createContext } from "react";

const BillContext = createContext();

export default BillContext;
